import { render } from "./OrderSummaryPanel.vue?vue&type=template&id=b2719576&ts=true"
import script from "./OrderSummaryPanel.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
